class SmartMapsApiLoader {
    loadApi () {
        return new Promise((resolve) => {
            const head = document.getElementsByTagName('head')[0];
            const script = document.createElement('script');
            const smartMapsUrl = 'https://www.yellowmap.de/api_rst/api/loader?libraries=free-3&apiKey=' + window.SMART_MAPS_API_KEY;
            script.setAttribute('src', smartMapsUrl);

            script.onload = () => {
                resolve();
            };

            head.appendChild(script);
        });
    }
}

export { SmartMapsApiLoader };
